import React from 'react';
import { withRouter } from 'react-router-dom';
import { ARROW_LEFT_WHITE, ARROW_LEFT } from '../../constants/defaultData';

class TopNav extends React.Component {
    constructor(props) {
        super(props);
    }

    goBack = () => {
        this.props.history.goBack();
    };

    render() {
        let {
            title,
            isHideTopNav,
            isHideBack,
            titleColor,
            bg,
            retrunEvent,
            black,
        } = this.props;
        bg = bg ? bg : '#fff';
        let titleStyles = {};
        if (titleColor) {
            titleStyles = {
                color: titleColor,
            };
        }
        if (retrunEvent) {
            return (
                <div
                    className={`TopNavBox ${isHideTopNav ? 'hidden' : ''}`}
                    style={{ backgroundColor: bg }}
                >
                    <a href="click:navigationback">
                        <img
                            className={`top-nav-white-arrow ${
                                isHideBack ? 'hidden' : ''
                            }`}
                            style={{ width: black ? '0.2rem' : '0.4rem' }}
                            src={black ? ARROW_LEFT : ARROW_LEFT_WHITE}
                            alt=""
                            // onClick={this.goBack}
                        />
                    </a>
                    <span className="top-nav-title" style={titleStyles}>
                        {title}
                    </span>
                    <span/>
                </div>
            );
        }

        return (
            <div
                className={`TopNavBox ${isHideTopNav ? 'hidden' : ''}`}
                style={{ backgroundColor: bg }}
            >
                <img
                    className={`top-nav-left-arrow ${
                        isHideBack ? 'hidden' : ''
                    }`}
                    src={ARROW_LEFT}
                    alt=""
                    onClick={this.goBack}
                />
                <span className="top-nav-title" style={titleStyles}>
                    {title}
                </span>
                <span/>
            </div>
        );
    }
}

export default withRouter(TopNav);
